import useRecipients from './useRecipients';

export default useRecipients;
